import styled from 'styled-components';

export default styled.textarea`
  border: ${props => props.theme.inputBorders};
  border-radius: ${props => props.theme.textareaBorderRadius};
  height: 150px;
  resize: vertical;
  font-size: ${props => props.theme.fontSizePrimary};
  ${props => (props.isInvalid ? `border-color: ${props.theme.invalidColor}` : '')};
`;
